// extracted by extract-css-chunks-webpack-plugin
module.exports = {"space90":"space90-3oRmy9cF","footcolumn":"footcolumn-2t2dwbXj"};